import type { LeadPayload } from './types';

type Attribution = Pick<LeadPayload, 'sourcePath'> & Partial<Pick<LeadPayload, 'referrer'|'utmSource'|'utmMedium'|'utmCampaign'|'utmContent'|'utmTerm'>>;
const storageKey = 'tripsoft:first-session-attribution';

function currentPath() {
  const requested = new URLSearchParams(window.location.search).get('sourcePath');
  const allowedContext = ['/b2b/', '/b2c/'];
  return (requested && allowedContext.includes(requested) ? requested : window.location.pathname).slice(0, 220);
}

export function captureAttribution(): Attribution {
  try {
    const stored = window.sessionStorage.getItem(storageKey);
    if (stored) return JSON.parse(stored) as Attribution;

    const params = new URLSearchParams(window.location.search);
    const firstTouch: Attribution = {sourcePath:currentPath()};
    const mapping = [
      ['source', 'utmSource', 80], ['medium', 'utmMedium', 80], ['campaign', 'utmCampaign', 120],
      ['content', 'utmContent', 120], ['term', 'utmTerm', 120],
    ] as const;
    for (const [queryKey, payloadKey, limit] of mapping) {
      const value = params.get(`utm_${queryKey}`)?.trim().slice(0, limit);
      if (value) firstTouch[payloadKey] = value;
    }
    if (document.referrer) {
      const referrer = new URL(document.referrer);
      firstTouch.referrer = `${referrer.origin}${referrer.pathname}`.slice(0, 500);
    }
    // This object is attribution-only by construction: form values never reach storage.
    window.sessionStorage.setItem(storageKey, JSON.stringify(firstTouch));
    return firstTouch;
  } catch {
    return {sourcePath:currentPath()};
  }
}

export function initializeAttribution(){ captureAttribution(); }
